import { render, staticRenderFns } from "./SyncForm.vue?vue&type=template&id=397936f6&scoped=true&"
import script from "./SyncForm.vue?vue&type=script&lang=js&"
export * from "./SyncForm.vue?vue&type=script&lang=js&"
import style0 from "./SyncForm.vue?vue&type=style&index=0&id=397936f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397936f6",
  null
  
)

export default component.exports